const locations = [
  'İstanbul Avrupa Yakası',
  'İstanbul Anadolu Yakası',
  'Silivri',
  'Tekirdağ',
  'Ankara',
];

const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function Locations() {
  return (
    <section id="hizmet-bolgeleri" className="bg-warm-white py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-navy mb-4">
            GENİŞ HİZMET BÖLGESİ
          </h2>
          <p className="text-navy/60 text-base md:text-lg max-w-2xl mx-auto">
            VİAYPİİ Temizlik farklı bölgelerde profesyonel temizlik taleplerini değerlendiriyor.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 mb-8">
          {locations.map((loc) => (
            <div
              key={loc}
              className="flex flex-col items-center gap-3 bg-white border border-warm-sand rounded-lg p-5 md:p-6 hover:border-gold/40 transition-colors"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-gold">
                <i className="ri-map-pin-2-line text-2xl md:text-3xl"></i>
              </div>
              <span className="text-navy font-semibold text-sm md:text-base text-center">{loc}</span>
            </div>
          ))}
        </div>

        <div className="bg-navy/5 border border-navy/10 rounded-lg p-5 md:p-6 text-center mb-8">
          <p className="text-navy/70 text-sm md:text-base">
            <span className="font-semibold">ve hizmet verilebilen çevre bölgeler</span>
          </p>
          <p className="text-navy/50 text-xs md:text-sm mt-2">
            Bölgenizde hizmet uygunluğunu öğrenmek için WhatsApp üzerinden iletişime geçebilirsiniz.
          </p>
        </div>

        <div className="text-center">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-navy hover:bg-navy-light text-white font-bold text-base rounded-md transition-colors"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Bölgem İçin Bilgi Al
          </a>
        </div>
      </div>
    </section>
  );
}